import IService from '../IService';

export default IService.extend({
  options: {
    /** use builtin result cache for rapid results retrieval */
    enableCache: true,
    MAX_CACHE_SIZE: 64,
  },

  initialize: function () {
    this.$ajax = null;
    this.cache = new Map();
  },

  _getUrl: function (options) {
    return app.apiUrl('/task/textTime/?' + $.param(options));
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  /**
   * @param programmerId
   * @param narratedText
   * @param options
   * @return {Deferred}
   */
  post: function (programmerId, narratedText, options) {
    const promise = new $.Deferred();

    options = $.extend(
      {
        withTokens: false,
      },
      options
    );

    if (!_.isDefined(programmerId)) {
      app.doctorController.report('app.api.textTime.post missing programmerId');
      promise.reject();
    } else {
      let response;

      if (_.isEmpty(narratedText)) {
        response = {
          averageNarrationTime: 0,
        };
        promise.resolve(response);
      } else if (this.options.enableCache && this.cache.has(narratedText)) {
        response = this.cache.get(narratedText);

        promise.resolve(response);
      } else {
        this.$ajax = $.ajax({
          url: this._getUrl(options),
          type: 'POST',
          data: {
            narratedText: narratedText,
            programmerId: programmerId,
          },
          error: function () {
            promise.reject();
          },
          timeout: app.TIME.MINUTE,
          success: function (response) {
            if (_.isObject(response) && 'OK' === response.response) {
              if (this.cache.size >= this.options.MAX_CACHE_SIZE) {
                // maintain cache size limit (FIFO)
                this.cache.delete(this.cache.keys().next().value);
              }
              this.cache.set(narratedText, response);
              promise.resolve(response);
            } else {
              promise.reject();
            }
          }.bind(this),
        }).always(() => {
          this.$ajax = null;
        });
      }
    }

    return promise;
  },
});
